const isLoggedIn: any = localStorage.getItem("isLoggedIn");
const user: any = localStorage.getItem("user");
export const initialState = {
  isAuthenticated: JSON.parse(isLoggedIn) || false,
  user: JSON.parse(user) || {},
  selectedTab: "Home sales",
  drawerOpen: false,
  filters: {
    state: "Florida",
    stateCord: {
      lat: 27.994402,
      lng: -81.760254,
    },
    heatMapCenter: {
      lat: '',
      lng: '',
    },
    selectedType: "predictedMetrics",
    stateLoading:false,
    trackEvent:'default',
    economicType: "Scaled",
    economicYears: [10, 23],
    regionType: "Zipcode",
    indicators: ["GDP"],
    selectedCluster: {id: 0},
    showCityCluster: false,
    showCityPrediction: false,
    city: [],
    county: [],
    neighborhood: [],
    zipcode: [],
    value: "trend",
    showInterval: false,
    years: [2018, 2028],
    predictionFor: "2024-11",
    quarterPredictionFor: "2024-11",
    zipcodeQuarterPredictionFor: "2024-10",
    noOfPrediction: 21,
    selectedTerritory: "Florida",
    profitability: null,
    showMarkers: true,
    showHeatMap:true,
    showFloodMap: false,
    showFireMap: false,
    schoolType:'Public',
    schoolRating:'All',
    showSchoolMap:false,
    showHurricaneMap:false,
    showHighRisk:false,
    showLayers:false,
    zipcodePrediction: [],
    heatMapMonths: '24',
    heatMapMiles: '300 Mile',
    predictionTill: {},
    heatmapTopRecords: 'All',
    totalHeatmapRecords: 0,
    whatIfSelectedCity: {},
    whatIfPercentage: 10.0,
    whatIfSubmit: false,
    hitSubmit: false,
    predictionsArray:[],
    adjustedPredictions: false,
    rentalValue: 'all_home_median_rental_price',
    homeSalesArray:['total_sales'],
    totalSales:true,
    reSales:false,
    newSales:false,
    defaultAdjustedPredictionValues: {
      status: false,
      quarter_1 : 0,
      quarter_2 : 0,
      quarter_3: 0,
      quarter_4 : 0,
      quarter_5 : 0,
      quarter_6 : 0,
      quarter_7 : 0,
      quarter_8 : 0,
      quarter_9 : 0,
      quarter_10 : 0,
      quarter_11 : 0,
      quarter_12 : 0,
      quarter_13 : 0,
      quarter_14 : 0,
      quarter_15 : 0,
      quarter_16 : 0,
      quarter_17 : 0,
      quarter_18 : 0,
      quarter_19 : 0,
      quarter_20 : 0
    },
    adjustedPredictionValues: {
      status: false,
      quarter_1 : 0,
      quarter_2 : 0,
      quarter_3: 0,
      quarter_4 : 0,
      quarter_5 : 0,
      quarter_6 : 0,
      quarter_7 : 0,
      quarter_8 : 0,
      quarter_9 : 0,
      quarter_10 : 0,
      quarter_11 : 0,
      quarter_12 : 0,
      quarter_13 : 0,
      quarter_14 : 0,
      quarter_15 : 0,
      quarter_16 : 0,
      quarter_17 : 0,
      quarter_18 : 0,
      quarter_19 : 0,
      quarter_20 : 0
    },
    submitAdjustedPrediction: false,
    refreshAdjustedPredictionSubmit: false,
    demographicValue: 'Age',
    crimeType: 'Property crime',

    adjustedSentimentsByConsumer: false,
    defaultAdjustedSentimentValuesByConsumer: {
      status: false,
      quarter_1 : 0,
      quarter_2 : 0,
      quarter_3: 0,
      quarter_4 : 0,
      quarter_5 : 0,
      quarter_6 : 0,
      quarter_7 : 0,
      quarter_8 : 0,
      quarter_9 : 0,
      quarter_10 : 0,
      quarter_11 : 0,
      quarter_12 : 0,
      quarter_13 : 0,
      quarter_14 : 0,
      quarter_15 : 0,
      quarter_16 : 0,
      quarter_17 : 0,
      quarter_18 : 0,
      quarter_19 : 0,
      quarter_20 : 0
    },
    adjustedSentimentValuesByConsumer: {
      status: false,
      quarter_1 : 0,
      quarter_2 : 0,
      quarter_3: 0,
      quarter_4 : 0,
      quarter_5 : 0,
      quarter_6 : 0,
      quarter_7 : 0,
      quarter_8 : 0,
      quarter_9 : 0,
      quarter_10 : 0,
      quarter_11 : 0,
      quarter_12 : 0,
      quarter_13 : 0,
      quarter_14 : 0,
      quarter_15 : 0,
      quarter_16 : 0,
      quarter_17 : 0,
      quarter_18 : 0,
      quarter_19 : 0,
      quarter_20 : 0
    },
    submitAdjustedSentimentByConsumer: false,
    refreshAdjustedSentimentSubmitByConsumer: false,
    adjustedSentimentsByBuilder: false,
    defaultAdjustedSentimentValuesByBuilder: {
      status: false,
      quarter_1 : 0,
      quarter_2 : 0,
      quarter_3: 0,
      quarter_4 : 0,
      quarter_5 : 0,
      quarter_6 : 0,
      quarter_7 : 0,
      quarter_8 : 0,
      quarter_9 : 0,
      quarter_10 : 0,
      quarter_11 : 0,
      quarter_12 : 0,
      quarter_13 : 0,
      quarter_14 : 0,
      quarter_15 : 0,
      quarter_16 : 0,
      quarter_17 : 0,
      quarter_18 : 0,
      quarter_19 : 0,
      quarter_20 : 0
    },
    adjustedSentimentValuesByBuilder: {
      status: false,
      quarter_1 : 0,
      quarter_2 : 0,
      quarter_3: 0,
      quarter_4 : 0,
      quarter_5 : 0,
      quarter_6 : 0,
      quarter_7 : 0,
      quarter_8 : 0,
      quarter_9 : 0,
      quarter_10 : 0,
      quarter_11 : 0,
      quarter_12 : 0,
      quarter_13 : 0,
      quarter_14 : 0,
      quarter_15 : 0,
      quarter_16 : 0,
      quarter_17 : 0,
      quarter_18 : 0,
      quarter_19 : 0,
      quarter_20 : 0
    },
    submitAdjustedSentimentByBuilder: false,
    refreshAdjustedSentimentSubmitByBuilder: false,
    cityRedirected:false
  },
};

export const authReducer = (state: any, action: any) => {
  switch (action.type) {
    case "IS_AUTHENTICATED":
      return {
        ...state,
        isAuthenticated: action.payload,
      };
    case "SET_USER":
      return {
        ...state,
        user: action.payload,
      };
    case "APPLY_FILTER":
      return {
        ...state,
        filters: action.payload,
      };
    case "SET_CLUSTER":
      return {
        ...state,
        filters: action.payload,
      };
    case "SET_TAB_SELECTION":
      return {
        ...state,
        selectedTab: action.payload,
      };
    case "LOGOUT":
      return {
        ...state,
        isAuthenticated: false,
        user: {},
        selectedTab: initialState.selectedTab,
        filters: initialState.filters,
      };
    case "SET_DRAWER_OPEN":
      return {
        ...state,
        drawerOpen: action.payload,
      };
    default:
      return state;
  }
};